import React from 'react';
import PropTypes from 'prop-types';

import UppyUploader from '@components/common/uppy/main';
import {
  formattedUppyAttachments,
  uniqueFilesByKey,
  duplicateSweetAlertOptions } from '@helpers/uppy';
import attachmentUploadTemplate from '@helpers/attachment_upload_template';

class AttachmentUppy extends React.Component {
  triggerUpload = (files) => {
    const uniqFiles = uniqueFilesByKey(files, "md5hash");
    if (files.length !== uniqFiles.length) {
      window.swal(duplicateSweetAlertOptions, (removeDuplicates) => {
        if (removeDuplicates) {
          this.stageAttachmentForUpload(formattedUppyAttachments(uniqFiles));
        } else {
          this.stageAttachmentForUpload(formattedUppyAttachments(files));
        }
      });
    } else {
      this.stageAttachmentForUpload(formattedUppyAttachments(files));
    }
  }

  stageAttachmentForUpload = (attachments) => {
    const { assetKey } = this.props;
    const $form = $('#dialog form.j-asset-submit');
    if (!$form.data('upload-queue')) { $form.data('upload-queue', []); }
    const upload_queue = $form.data('upload-queue');

    attachments.forEach((attachment) => {
      upload_queue.push(attachment);
      $('#dialog form.j-asset-submit').attr('data-upload-queue', JSON.stringify(upload_queue));
      $('.j-edit-attachments-container').append(attachmentUploadTemplate(attachment, assetKey));
    });

    $form.attr('data-locked', "true");

    const $thumbImage = $('.m-modal-preview .card-thumbnail img');
    if ($thumbImage[0].currentSrc.indexOf("empty.svg")) {
      $thumbImage.attr('src', attachments[0].url);
      $(".m-modal-preview .j-asset-name").text('Pending changes...');
    }

    $(".j-assets-tip h5").html(t('You must first click "Update" to enable ordering of new attachments.'));
    Insight.createEvent('added_attachments', assetKey, 'asset');
  }

  trigger = () => `uppy-asset-upload-trigger-${this.props.assetKey}`

  renderArea() {
    return (
      <div id={this.trigger()} className="uppy-attachment-area">
        <p>{t("Click to add an attachment")}</p>
      </div>
    );
  }

  render() {
    return (
      <React.Fragment>
        {this.renderArea()}
        <UppyUploader
          {...this.props}
          handleUpload={this.triggerUpload}
          uniqIdentifier={`attachment-uppy-${this.props.assetKey}`}
          button
          trigger={`#${this.trigger()}`}
        />
      </React.Fragment>
    );
  }
}

AttachmentUppy.propTypes = {
  assetKey: PropTypes.string.isRequired
};

export default AttachmentUppy;
